import { useTheme } from '@mui/material';

export default function NoResults() {
  const theme = useTheme();
  return (
    <svg width='220' height='170' viewBox='0 0 258 175' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g id='No Results'>
        <g id='circle'>
          <path
            id='Stroke 1'
            d='M8.99609 97.0703V99.2476'
            stroke='#B0B9C2'
            stroke-width='2.11992'
            stroke-linecap='round'
          />
          <g id='Group 8'>
            <path
              id='Stroke 2'
              d='M4.08984 98.2578L5.87515 100.089'
              stroke='#B0B9C2'
              stroke-width='2.11992'
              stroke-linecap='round'
            />
            <path id='Stroke 4' d='M2 103.133H4.5244' stroke='#B0B9C2' stroke-width='2.11992' stroke-linecap='round' />
            <path
              id='Stroke 6'
              d='M3.88281 108.097L5.66812 106.266'
              stroke='#B0B9C2'
              stroke-width='2.11992'
              stroke-linecap='round'
            />
          </g>
          <path
            id='Stroke 9'
            d='M8.99609 108.685V106.508'
            stroke='#B0B9C2'
            stroke-width='2.11992'
            stroke-linecap='round'
          />
          <path
            id='Stroke 10'
            d='M12.6362 107.233L11.1797 105.781'
            stroke='#B0B9C2'
            stroke-width='2.11992'
            stroke-linecap='round'
          />
          <path
            id='Stroke 11'
            d='M15.5481 103.602H13.3633'
            stroke='#B0B9C2'
            stroke-width='2.11992'
            stroke-linecap='round'
          />
          <path
            id='Stroke 12'
            d='M14.0933 98.5234L12.6367 99.9749'
            stroke='#B0B9C2'
            stroke-width='2.11992'
            stroke-linecap='round'
          />
          <path id='Stroke 13' d='M126.246 2V3.4515' stroke='#B0B9C2' stroke-width='2.11992' stroke-linecap='round' />
          <path
            id='Stroke 15'
            d='M121.875 6.35156H123.332'
            stroke='#B0B9C2'
            stroke-width='2.11992'
            stroke-linecap='round'
          />
          <path
            id='Stroke 16'
            d='M126.246 10.7093V9.25781'
            stroke='#B0B9C2'
            stroke-width='2.11992'
            stroke-linecap='round'
          />
          <path
            id='Stroke 17'
            d='M129.89 6.35156H128.434'
            stroke='#B0B9C2'
            stroke-width='2.11992'
            stroke-linecap='round'
          />
          <path
            id='Stroke 18'
            d='M41.7656 62.9609V65.1382'
            stroke='#B0B9C2'
            stroke-width='2.11992'
            stroke-linecap='round'
          />
          <path
            id='Stroke 19'
            d='M35.2109 69.4922H37.3958'
            stroke='#B0B9C2'
            stroke-width='2.11992'
            stroke-linecap='round'
          />
          <path
            id='Stroke 20'
            d='M41.7656 75.3023V73.125'
            stroke='#B0B9C2'
            stroke-width='2.11992'
            stroke-linecap='round'
          />
          <path
            id='Stroke 21'
            d='M47.5911 69.4922H45.4062'
            stroke='#B0B9C2'
            stroke-width='2.11992'
            stroke-linecap='round'
          />
          <g id='Group 42'>
            <path
              id='Stroke 22'
              d='M198.535 142.094C200.275 142.094 201.687 143.501 201.687 145.236C201.687 146.971 200.275 148.377 198.535 148.377C196.794 148.377 195.383 146.971 195.383 145.236'
              stroke='#B0B9C2'
              stroke-width='2.11992'
              stroke-linecap='round'
            />
            <path
              id='Fill 26'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M212.957 113.59C214.829 113.008 217.697 110.728 218.361 108.273C218.964 110.443 221.488 113.008 223.766 113.203C221.202 114.107 218.75 116.795 218.361 118.906C218.097 116.754 214.706 113.904 212.957 113.59Z'
              fill='#EBECEE'
            />
            <path
              id='Fill 28'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M20.8438 141.127C21.7798 140.836 23.2136 139.696 23.5456 138.469C23.8467 139.553 25.1086 140.836 26.2475 140.933C24.9658 141.385 23.7404 142.729 23.5456 143.785C23.4133 142.709 21.718 141.283 20.8438 141.127Z'
              fill='#EBECEE'
            />
            <path
              id='Fill 30'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M38.2162 40.1628C38.2162 41.5088 37.1218 42.599 35.7722 42.599C34.4218 42.599 33.3281 41.5088 33.3281 40.1628C33.3281 38.8174 34.4218 37.7266 35.7722 37.7266C37.1218 37.7266 38.2162 38.8174 38.2162 40.1628Z'
              fill='#D1D8DF'
            />
            <path
              id='Fill 32'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M201.42 46.7125C201.42 48.9613 199.591 50.7843 197.336 50.7843C195.079 50.7843 193.25 48.9613 193.25 46.7125C193.25 44.4636 195.079 42.6406 197.336 42.6406C199.591 42.6406 201.42 44.4636 201.42 46.7125Z'
              fill='#EBECEE'
            />
            <path
              id='Fill 34'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M258 35.6753C258 37.4595 256.549 38.9053 254.76 38.9053C252.97 38.9053 251.52 37.4595 251.52 35.6753C251.52 33.8911 252.97 32.4453 254.76 32.4453C256.549 32.4453 258 33.8911 258 35.6753Z'
              fill='#EBECEE'
            />
            <path
              id='Stroke 38'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M82.6732 24.5143C82.6732 25.8603 81.5789 26.9505 80.2292 26.9505C78.8795 26.9505 77.7852 25.8603 77.7852 24.5143C77.7852 23.169 78.8795 22.0781 80.2292 22.0781C81.5789 22.0781 82.6732 23.169 82.6732 24.5143Z'
              stroke='#B0B9C2'
              stroke-width='2.11992'
              stroke-linecap='round'
            />
          </g>
        </g>
        <g id='search'>
          <g id='documents'>
            <path
              id='Fill 1'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M144.089 151.505H84.3669C80.1634 151.505 76.7227 148.066 76.7227 143.863V58.9919C76.7227 54.7889 80.1634 51.3516 84.3669 51.3516H144.089C148.294 51.3516 151.735 54.7889 151.735 58.9919V143.863C151.735 148.066 148.294 151.505 144.089 151.505Z'
              fill='#E0E2EE'
            />
            <path
              id='Fill 3'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M138.995 155.13H79.2732C75.0697 155.13 71.6289 151.691 71.6289 147.488V62.6169C71.6289 58.4139 75.0697 54.9766 79.2732 54.9766H138.995C143.2 54.9766 146.641 58.4139 146.641 62.6169V147.488C146.641 151.691 143.2 155.13 138.995 155.13Z'
              fill='#E8EBF2'
            />
            <path
              id='Fill 5'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M134.033 157.997H74.1874C69.9752 157.997 66.5273 154.572 66.5273 150.386V65.8665C66.5273 61.6809 69.9752 58.2578 74.1874 58.2578H134.033C138.246 58.2578 141.694 61.6809 141.694 65.8665V150.386C141.694 154.572 138.246 157.997 134.033 157.997Z'
              fill='#D8DBEA'
            />
            <path
              id='Fill 8'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M134.033 157.997H74.1874C69.9752 157.997 66.5273 154.572 66.5273 150.386V65.8665C66.5273 61.6809 69.9752 58.2578 74.1874 58.2578H134.033C138.246 58.2578 141.694 61.6809 141.694 65.8665V150.386C141.694 154.572 138.246 157.997 134.033 157.997Z'
              fill='#F1F2F7'
            />
            <path
              id='Fill 11'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M125.405 84.0108H81.2019C79.9396 84.0108 78.9062 83.0311 78.9062 81.8343C78.9062 80.6359 79.9396 79.6562 81.2019 79.6562H125.405C126.667 79.6562 127.7 80.6359 127.7 81.8343C127.7 83.0311 126.667 84.0108 125.405 84.0108Z'
              fill='#E0E2EE'
            />
            <path
              id='Fill 13'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M125.405 97.0733H81.2019C79.9396 97.0733 78.9062 96.0936 78.9062 94.8968C78.9062 93.6984 79.9396 92.7188 81.2019 92.7188H125.405C126.667 92.7188 127.7 93.6984 127.7 94.8968C127.7 96.0936 126.667 97.0733 125.405 97.0733Z'
              fill='#E0E2EE'
            />
            <path
              id='Fill 15'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M125.405 110.136H81.2019C79.9396 110.136 78.9062 109.156 78.9062 107.959C78.9062 106.763 79.9396 105.781 81.2019 105.781H125.405C126.667 105.781 127.7 106.763 127.7 107.959C127.7 109.156 126.667 110.136 125.405 110.136Z'
              fill='#E0E2EE'
            />
            <path
              id='Fill 17'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M125.405 123.198H81.2019C79.9396 123.198 78.9062 122.219 78.9062 121.022C78.9062 119.823 79.9396 118.844 81.2019 118.844H125.405C126.667 118.844 127.7 119.823 127.7 121.022C127.7 122.219 126.667 123.198 125.405 123.198Z'
              fill='#E0E2EE'
            />
            <path
              id='Fill 19'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M104.275 136.261H81.2117C79.944 136.261 78.9062 135.281 78.9062 134.084C78.9062 132.886 79.944 131.906 81.2117 131.906H104.275C105.543 131.906 106.581 132.886 106.581 134.084C106.581 135.281 105.543 136.261 104.275 136.261Z'
              fill='#E0E2EE'
            />
          </g>
          <g id='search_2'>
            <path
              id='Fill 21'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M150.83 119.385C141.992 128.192 128.308 129.186 118.374 122.386C117.104 121.502 115.896 120.508 114.769 119.385C114.189 118.809 113.642 118.215 113.127 117.589C112.096 116.338 111.194 115.005 110.454 113.627C109.151 111.301 108.265 108.832 107.782 106.28C106.221 98.2761 108.555 89.6615 114.769 83.4714C120.998 77.263 129.644 74.9528 137.677 76.4929C140.236 76.9897 142.716 77.8724 145.051 79.1558C146.436 79.9092 147.756 80.8086 149.012 81.8353C149.639 82.3468 150.235 82.8934 150.814 83.4714C151.942 84.5942 152.954 85.7964 153.825 87.0632C160.651 96.9595 159.652 110.595 150.83 119.385Z'
              fill='white'
              fill-opacity='0.1'
            />
            <path
              id='Fill 23'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M148.355 117.652C139.159 126.818 124.257 126.816 115.059 117.652C105.874 108.498 105.874 93.6461 115.071 84.4823C124.257 75.3288 139.159 75.3288 148.344 84.4823C157.54 93.6461 157.54 108.498 148.355 117.652ZM153.074 79.775C141.271 68.0125 122.144 68.0125 110.341 79.775C98.5391 91.5358 98.5288 110.609 110.33 122.371C121.073 133.073 137.91 134.038 149.753 125.251C150.91 124.392 152.024 123.428 153.086 122.371C154.147 121.312 155.114 120.202 155.975 119.049C164.792 107.246 163.815 90.4786 153.074 79.775Z'
              fill='#B0B9C2'
            />
            <path
              id='Fill 25'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M199.529 166.708L199.033 167.201C195.755 170.47 190.386 170.47 187.106 167.201L156.836 137.036L169.258 124.656L199.529 154.822C202.809 158.091 202.809 163.439 199.529 166.708Z'
              fill={theme.palette.primary.main}
            />
            <path
              id='Fill 27'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M156.63 118.125L165.575 127.039L159.225 133.366L150.281 124.452C151.462 123.575 152.597 122.592 153.683 121.513C154.765 120.434 155.752 119.301 156.63 118.125Z'
              fill='#B0B9C2'
            />
            <path
              id='Fill 29'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M199.073 154.451L186.73 166.749L184.508 164.533L196.849 152.234L199.073 154.451Z'
              fill='#EAE6FD'
            />
            <path
              id='Fill 31'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M169.944 125.081L157.263 137.718L155.379 135.841L168.06 123.203L169.944 125.081Z'
              fill='#EAE6FD'
            />
            <path
              id='Fill 33'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M142.266 81.3315L111.166 112.322C109.995 110.23 109.199 108.011 108.766 105.716L135.637 78.9375C137.938 79.3857 140.167 80.1777 142.266 81.3315Z'
              fill='white'
              fill-opacity='0.5'
            />
            <path
              id='Fill 35'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M152.466 88.6956L118.843 120.303C117.639 119.513 116.493 118.624 115.425 117.62C114.874 117.102 114.354 116.572 113.867 116.012L147.899 84.0156C148.495 84.475 149.061 84.9642 149.609 85.4814C150.678 86.4861 151.639 87.5619 152.466 88.6956Z'
              fill='white'
              fill-opacity='0.5'
            />
          </g>
        </g>
        <ellipse id='shadow' cx='109.373' cy='169' rx='69.2403' ry='6' fill={theme.palette.primary.light} />
      </g>
    </svg>
  );
}
